import {
  Field,
  CheckboxField,
  RadioField,
} from 'signer-app/types/editor-types';

/**
 * Determines if a checkbox/radio field should count toward requiredFieldsLeft.
 *
 * When shouldUseFixedCounter is true, only the first field in a group is
 * counted. This avoids over-counting group members as separate required fields.
 */
export function checkIsGroupFieldRequired(
  visibleFields: Field[],
  field: CheckboxField | RadioField,
  shouldUseFixedCounter: boolean = false,
): boolean {
  const requirement = field.requirement;
  if (shouldUseFixedCounter) {
    if (field.group == null) {
      return !!field.required && !field.checked;
    }
    const sameGroupFields = visibleFields.filter(
      (f) => f.type === field.type && f.group === field.group,
    );
    if (sameGroupFields[0].id !== field.id) {
      return false;
    }
    if (requirement === 'require_0-1') {
      return false;
    }
  }
  const checkedFields = visibleFields.filter(
    (f) => f.type === field.type && f.group === field.group && f.checked,
  );
  if (requirement === 'require_0-1') {
    return checkedFields.length === 0;
  }
  const minimumRequired = Number(requirement?.match(/\d+/)?.[0]);
  return checkedFields.length < minimumRequired;
}
